import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISmartCooler, ISmartCoolerResponse } from "@/pages/SmartCoolers/smartCooler.interface";
import { IFetchCoolersParams, ICoolerActionPayload } from "@/services/smartCooler";

export interface ICoolerActionResult {
    actionId: string;
    coolerId: string;
    actionType: string;
    status: string;
    requestedBy: string;
    payload?: Record<string, any>;
    createdOn: string;
}

export interface IActionSuccessPayload {
    message: string | null;
    data: ICoolerActionResult | null;
}

export interface SmartCoolerState {
    listLoading: boolean;
    listError: string | null;
    data: ISmartCooler[];
    pagination: ISmartCoolerResponse["pagination"] | null;
    actionLoading: boolean;
    actionSuccess: boolean;
    actionMessage: string | null;
    actionData: ICoolerActionResult | null;
    actionError: string | null;
}

const initialState: SmartCoolerState = {
    listLoading: false,
    listError: null,
    data: [],
    pagination: null,
    actionLoading: false,
    actionSuccess: false,
    actionMessage: null,
    actionData: null,
    actionError: null,
};

const smartCoolerSlice = createSlice({
    name: "smartCooler",
    initialState,
    reducers: {
        fetchCoolerList: (state, _action: PayloadAction<IFetchCoolersParams>) => {
            state.listLoading = true;
            state.listError = null;
        },
        fetchCoolerListSuccess: (state, action: PayloadAction<ISmartCoolerResponse>) => {
            state.listLoading = false;
            state.data = action.payload.data;
            state.pagination = action.payload.pagination;
        },
        fetchCoolerListFailure: (state, action: PayloadAction<string>) => {
            state.listLoading = false;
            state.listError = action.payload;
            state.data = [];
        },
        triggerCoolerAction: (state, _action: PayloadAction<ICoolerActionPayload>) => {
            state.actionLoading = true;
            state.actionSuccess = false;
            state.actionError = null;
        },
        triggerCoolerActionSuccess: (state, action: PayloadAction<IActionSuccessPayload>) => {
            state.actionLoading = false;
            state.actionSuccess = true;
            state.actionMessage = action.payload.message;
            state.actionData = action.payload.data;
            state.actionError = null;
        },
        triggerCoolerActionFailure: (state, action: PayloadAction<string>) => {
            state.actionLoading = false;
            state.actionSuccess = false;
            state.actionMessage = null;
            state.actionData = null;
            state.actionError = action.payload;
        },
        resetCoolerAction: (state) => {
            state.actionLoading = false;
            state.actionSuccess = false;
            state.actionMessage = null;
            state.actionData = null;
            state.actionError = null;
        },
    },
});

export const {
    fetchCoolerList,
    fetchCoolerListSuccess,
    fetchCoolerListFailure,
    triggerCoolerAction,
    triggerCoolerActionSuccess,
    triggerCoolerActionFailure,
    resetCoolerAction,
} = smartCoolerSlice.actions;

export default smartCoolerSlice.reducer;
